import { _ep0, _mw0, command } from "../commandBuilder";
import { ListInvitation$ } from "../schemas/schemas_0";
export class ListInvitationCommand extends command(_ep0, _mw0, "ListInvitation", ListInvitation$) {
}
